import { Box, Button, Flex, HStack, Image, Separator, Stack, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import { API } from "config"
import { toaster } from "config"
import { useState } from "react"
import { useLocation, useNavigate } from "react-router"

export default function Reset(){

    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const [ password, setPassword ] = useState()
    const [ password_retype, setPasswordRetype ] = useState()
    const [ loading, setLoading ] = useState(false)
    const otp_code = params.get('otp_code')
    const email = params.get('email')

    const enabled = password?.length >= 6 && password_retype === password

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put('/recovery', { otp_code, password, email })
            toaster.create({ title: 'Sua senha foi redefinida', description: 'Faça login para continuar', type: 'success' })
            navigate('/')
        }catch(err){
            toaster.create({ title: 'Não foi possível atualizar a senha.', description: err?.response?.data?.message, type: 'warning'})
            setLoading(false)
        }
    }

    return(
    <Flex h="100vh" overflow="hidden">

        {/* ── Painel esquerdo: Identidade da marca ── */}
        <Flex
            hideBelow="lg"
            flex="1"
            direction="column"
            align="center"
            justify="center"
            position="relative"
            overflow="hidden"
            style={{ background: 'linear-gradient(160deg, #0f172a 0%, #1e2d4d 60%, #0f172a 100%)' }}
            p={12}
            gap={10}
        >
            <Box position="absolute" top="-80px" right="-80px" w="360px" h="360px" borderRadius="full" style={{ background: 'rgba(251,146,60,0.07)' }} />
            <Box position="absolute" bottom="-120px" left="-60px" w="440px" h="440px" borderRadius="full" style={{ background: 'rgba(251,146,60,0.05)' }} />
            <Box position="absolute" top="42%" left="-50px" w="220px" h="220px" borderRadius="full" style={{ background: 'rgba(251,146,60,0.04)' }} />

            <Stack align="center" gap={5} zIndex={1} w="100%" maxW="320px">
                <HStack gap={4}>
                    <Image src="/icon.png" h="64px" />
                    <Box>
                        <Text color="white" fontWeight="bold" fontSize="3xl" lineHeight="1">Bonífica</Text>
                        <Text color="orange.300" fontSize="sm" mt={1}>Escritório de Núcleos</Text>
                    </Box>
                </HStack>

                <Box h="1px" bg="rgba(255,255,255,0.12)" w="100%" />

                <Box textAlign="center">
                    <Text color="white" fontSize="xl" fontWeight="semibold" lineHeight="1.5">
                        Criar nova<br />senha de acesso
                    </Text>
                    <Text mt={3} fontSize="sm" style={{ color: 'rgba(255,255,255,0.55)' }} lineHeight="1.6">
                        Escolha uma senha segura com<br />no mínimo 6 caracteres.
                    </Text>
                </Box>
            </Stack>

            <Stack gap={4} zIndex={1} w="100%" maxW="300px">
                {[
                    { icon: 'key', text: 'Mínimo de 6 caracteres' },
                    { icon: 'check', text: 'Confirme a nova senha' },
                    { icon: 'identity', text: 'Acesso vinculado ao seu e-mail' },
                ].map(({ icon, text }) => (
                    <HStack key={text} gap={3}>
                        <Box p={2} borderRadius={6} style={{ background: 'rgba(251,146,60,0.15)' }} flexShrink={0}>
                            <UI.Icon name={icon} color="orange.300" boxSize={4} />
                        </Box>
                        <Text fontSize="sm" style={{ color: 'rgba(255,255,255,0.75)' }}>{text}</Text>
                    </HStack>
                ))}
            </Stack>
        </Flex>

        {/* ── Painel direito: Formulário ── */}
        <Flex
            flex={{ base: 1, lg: '0 0 460px' }}
            direction="column"
            align="center"
            justify="center"
            p={8}
            bg="bg"
        >
            <Stack gap={6} w="100%" maxW="380px">

                <HStack hideFrom="lg" gap={3} justify="center">
                    <Image src="/icon.png" h="36px" />
                    <Box>
                        <Text fontWeight="bold" fontSize="lg">Bonífica</Text>
                        <Text fontSize="xs" color="fg.muted">Escritório de Núcleos</Text>
                    </Box>
                </HStack>

                <Box>
                    <Text fontSize="2xl" fontWeight="bold">Nova senha</Text>
                    <Text color="fg.muted" fontSize="sm" mt={1}>Crie uma nova senha para sua conta</Text>
                </Box>

                <Form.Container onSubmit={handleSubmit}>
                    <Form.Text
                        disabled
                        label="E-mail"
                        type="email"
                        value={email}
                    />
                    <Form.Password
                        required
                        autoFocus
                        label="Nova senha"
                        placeholder="••••••••"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        disabled={loading}
                        helper="Sua senha precisa ter no mínimo 6 caracteres."
                    />
                    <Form.Password
                        required
                        label="Confirme a nova senha"
                        placeholder="••••••••"
                        value={password_retype}
                        onChange={e => setPasswordRetype(e.target.value)}
                        disabled={loading}
                    />
                    <Button
                        type="submit"
                        w="100%"
                        size="lg"
                        colorPalette="orange"
                        disabled={!enabled}
                        loading={loading}
                        loadingText="Atualizando..."
                    >
                        <UI.Icon name="key" /> Alterar senha
                    </Button>
                </Form.Container>

                <HStack gap={3}>
                    <Separator flex="1" />
                    <Text fontSize="xs" color="fg.subtle">ou</Text>
                    <Separator flex="1" />
                </HStack>

                <Button w="100%" variant="ghost" onClick={() => navigate('/')} disabled={loading}>
                    <UI.Icon name="prev" /> Voltar para o login
                </Button>

            </Stack>
        </Flex>

    </Flex>
    )
}
